export const iohLevelTwoTerminalPositions = [
  {
    uid: '4',
    schematicId: '4',
    name: 'BEDFORD PARK',
    abbrevation: 'BED',
    code: 'BEDTRM',
    startX: 70,
    startY: 625,
    direction: 5,
    milepost:'000ZA3'
  },
  {
    uid: '5',
    schematicId: '5',
    name: 'BESSEMER',
    code: 'BESTRM',
    abbrevation: 'BES',
    startX: 473,
    startY: 2585,
    direction: 4,
    milepost:'0LB407'
  },
  {
    uid: '6',
    schematicId: '6',
    name: 'BUFFALO ICTF',
    code: 'BUFTRM',
    abbrevation: 'BUF',
    startX: 2292,
    startY: 345,
    direction: 4,
    milepost:'QD   6'
  },
  {
    uid: '8',
    schematicId: '8',
    name: 'CCX',
    abbrevation: 'CCX',
    code: 'CCXTRM',
    startX: 2572,
    startY: 2025,
    direction: 5,
    milepost:'A  116'
  },
  {
    uid: '10',
    schematicId: '10',
    name: 'CHAMBERSBURG',
    code: 'CHATRM',
    abbrevation: 'CHA',
    startX: 2852,
    startY: 905,
    direction: 5,
    milepost:'BAV 21'
  },
  {
    uid: '11',
    schematicId: '11',
    name: 'CHARLESTON',
    abbrevation: 'CHS',
    code: 'CHSTRM',
    startX: 2292,
    startY: 2305,
    direction: 4,
    milepost:'A  390'
  },
  {
    uid: '12',
    schematicId: '12',
    name: 'CHARLOTTE',
    abbrevation: 'CNC',
    code: 'CNCTRM',
    startX: 2012,
    startY: 1773,
    direction: 5,
    milepost:'SF 330'
  },
  {
    uid: '2',
    schematicId: '22',
    name: 'CHICAGO 59TH STREET',
    abbrevation: 'FIV',
    code: 'FIVTRM',
    startX: 70,
    startY: 345,
    direction: 5,
    milepost:'DCQ 25'
  },
  {
    uid: '14',
    schematicId: '14',
    name: 'CINCINNATI',
    abbrevation: 'CIN',
    code: 'CINTRM',
    startX: 1173,
    startY: 1465,
    direction: 4,
    milepost:'00T110'
  },
  {
    uid: '15',
    schematicId: '15',
    name: 'CLEVELAND',
    abbrevation: 'CLE',
    code: 'CLETRM',
    startX: 2292,
    startY: 625,
    direction: 4,
    milepost:'QD 173'
  },
  {
    uid: '16',
    schematicId: '16',
    name: 'COLUMBUS',
    abbrevation: 'COL',
    code: 'COLTRM',
    startX: 1732,
    startY: 1185,
    direction: 4,
    milepost:'QTB  2'
  },
  {
    uid: '18',
    schematicId: '18',
    name: 'DETROIT',
    abbrevation: 'DET',
    code: 'DETTRM',
    startX: 1732,
    startY: 65,
    direction: 4,
    milepost:'QQM  2'
  },
  {
    uid: '21',
    schematicId: '21',
    name: 'EAST ST LOUIS',
    abbrevation: 'EST',
    code: 'ESTTRM',
    startX: 70,
    startY: 905,
    direction: 5,
    milepost:'QS 235'
  },
  {
    uid: '23',
    schematicId: '23',
    name: 'FAIRBURN',
    abbrevation: 'FAB',
    code: 'FABTRM',
    startX: 1170,
    startY: 2305,
    direction: 4,
    milepost:'XXB023'
  },
  {
    uid: '30',
    schematicId: '30',
    name: 'INDIANAPOLIS ICTF',
    abbrevation: 'INR',
    code: 'INRTRM',
    startX: 892,
    startY: 905,
    direction: 5,
    milepost:'QS   9'
  },
  {
    uid: '29',
    schematicId: '29',
    name: 'INDIANAPOLIS',
    abbrevation: 'IND',
    code: 'INDTRM',
    startX: 612,
    startY: 905,
    direction: 5,
    milepost:'QS   9'
  },
  {
    uid: '20',
    schematicId: '20',
    name: 'JACKSONVILLE',
    abbrevation: 'JAX',
    code: 'JAXTRM',
    startX: 1452,
    startY: 2865,
    direction: 4,
    milepost: 'A  640'
  },
  {
    uid: '31',
    schematicId: '31',
    name: 'KEARNY',
    abbrevation: 'KRN',
    code: 'KRNTRM',
    startX: 3130,
    startY: 625,
    direction: 4,
    milepost:'QK   3'
  },
  {
    uid: '33',
    schematicId: '33',
    name: 'LOUISVILLE',
    abbrevation: 'LOU',
    code: 'LOUTRM',
    startX: 752,
    startY: 1465,
    direction: 5,
    milepost:'000006'
  },
  {
    uid: '37',
    schematicId: '37',
    name: 'MEMPHIS',
    abbrevation: 'MEM',
    code: 'MEMTRM',
    startX: 70,
    startY: 2025,
    direction: 5,
    milepost: '00F371'
  },
  {
    uid: '39',
    schematicId: '39',
    name: 'NASHVILLE',
    code: 'NSHTRM',
    abbrevation: 'NSH',
    startX: 473,
    startY: 2025,
    direction: 4,
    milepost:'000190'
  },
  {
    uid: '41',
    schematicId: '41',
    name: 'NEW ORLEANS',
    abbrevation: 'NOL',
    code: 'NOLTRM',
    startX: 52,
    startY: 2865,
    direction: 5,
    milepost:'000801'
  },
  {
    uid: '42',
    schematicId: '42',
    name: 'NORTH BERGEN',
    abbrevation: 'NBE',
    code: 'NBETRM',
    startX: 2852,
    startY: 625,
    direction: 5,
    milepost:'QR   1'
  },
  {
    uid: '43',
    schematicId: '43',
    name: 'NORTHWEST OHIO',
    abbrevation: 'NOW',
    code: 'NOWTRM',
    startX: 1452,
    startY: 625,
    direction: 5,
    milepost:'BI  51'
  },
  {
    uid: '44',
    schematicId: '44',
    name: 'PHILADELPHIA',
    abbrevation: 'PHI',
    code: 'PHITRM',
    startX: 3132,
    startY: 905,
    direction: 4,
    milepost:'BBF  8'
  },
  {
    uid: '50',
    schematicId: '50',
    name: 'SAVANNAH',
    code: 'SAVTRM',
    abbrevation: 'SAV',
    startX: 1732,
    startY: 2585,
    direction: 5,
    milepost:'A  496'
  },
  {
    uid: '54',
    schematicId: '54',
    name: 'SPRINGFIELD',
    code: 'SPRTRM',
    abbrevation: 'SPR',
    startX: 3132,
    startY: 345,
    direction: 5,
    milepost:'QB 100'
  },
  {
    uid: '55',
    schematicId: '55',
    name: 'SYRACUSE',
    abbrevation: 'SYR',
    code: 'SYRTRM',
    startX: 2572,
    startY: 345,
    direction: 5,
    milepost:'QC 285'
  },
  {
    uid: '56',
    schematicId: '56',
    name: 'TAMPA',
    abbrevation: 'TAM',
    code: 'TAMTRM',
    startX: 1170,
    startY: 3145,
    direction: 5,
    milepost:'S  841'
  },
  {
    uid: '9',
    schematicId: '9',
    name: 'WINTER HAVEN',
    code: 'WINTRM',
    abbrevation: 'WIN',
    startX: 1732,
    startY: 3145,
    direction: 5,
    milepost:'SX 833'
  },
  {
    uid: '63',
    schematicId: '63',
    name: 'WORCESTER',
    code: 'WORTRM',
    abbrevation: 'WOR',
    startX: 3412,
    startY: 345,
    direction: 5,
    milepost:'QB  45'
  },
  {
    uid: '48',
    schematicId: '48',
    name: 'RICHMOND JUNCTION',
    code: 'RICTRM',
    abbrevation: 'RIC',
    startX: 2573,
    startY: 1465,
    direction: 2
  },
  {
    uid: '59',
    schematicId: '59',
    name: 'VITIS JUNCTION',
    code: 'VITTRM',
    abbrevation: 'VIT',
    startX: 1453,
    startY: 3145,
    direction: 2
  },
  {
    uid: '84',
    schematicId: '84',
    name: 'CHERRY RUN JUNCTION',
    code: 'CHYTRM',
    abbrevation: 'CHY',
    startX: 2573,
    startY: 905,
    direction: 2
  },
  {
    uid: '19',
    schematicId: '19',
    name: 'DILLON JUNCTION',
    code: 'DILLTRM',
    abbrevation: 'DILL',
    startX: 2293,
    startY: 2025,
    direction: 8
  },
  {
    uid: '38',
    schematicId: '38',
    name: 'MONTGOMERY JUNCTION',
    code: 'MTGTRM',
    abbrevation: 'MTG',
    startX: 472,
    startY: 2865,
    direction: 2
  },
  {
    uid: '46',
    schematicId: '46',
    name: 'SCIOTOVILLE JUNCTION',
    code: 'SCOTRM',
    abbrevation: 'SCO',
    startX: 1733,
    startY: 1465,
    direction: 2
  },
  {
    uid: '57',
    schematicId: '57',
    name: 'TERRE HAUTE JUNCTION',
    code: 'TERTRM',
    abbrevation: 'TER',
    startX: 332,
    startY: 905,
    direction: 2
  },
  {
    uid: '32',
    schematicId: '32',
    name: 'LAGRANGE JUNCTION',
    code: 'LAGTRM',
    abbrevation: 'LAG',
    startX: 893,
    startY: 2585,
    direction: 2
  },
  {
    uid: '26',
    schematicId: '26',
    name: 'GRAND RAPIDS JUNCTION',
    code: 'GRPTRM',
    abbrevation: 'GRP',
    startX: 614,
    startY: 345,
    direction: 2
  },
  {
    uid: '27',
    schematicId: '27',
    name: 'GREENWHICH JUNCTION',
    code: 'GRNTRM',
    abbrevation: 'GRN',
    startX: 2293,
    startY: 905,
    direction: 2
  },
  {
    uid: '25',
    schematicId: '25',
    name: 'GALATEA JUNCTION',
    code: 'GALTRM',
    abbrevation: 'GAL',
    startX: 1733,
    startY: 625,
    direction: 2
  },

  {
    uid: '28',
    schematicId: '28',
    name: 'HAMILTON JUNCTION',
    code: 'HLTTRM',
    abbrevation: 'HLT',
    startX: 1173,
    startY: 1185,
    direction: 2
  },
  {
    uid: '58',
    schematicId: '58',
    name: 'TOLEDO JUNCTION',
    code: 'TOLTRM',
    abbrevation: 'TOL',
    startX: 1733,
    startY: 345,
    direction: 2
  },
  {
    uid: '60',
    schematicId: '60',
    name: 'WASHINGTON DC JUNCTION',
    code: 'WASTRM',
    abbrevation: 'WAS',
    startX: 2573,
    startY: 1185,
    direction: 2
  },
  {
    uid: '3',
    schematicId: '3',
    name: "BALTIMORE_JUNCTION",
    code: 'BALTRM',
    abbrevation: 'BAL',
    startX: 3133,
    startY: 1185,
    direction: 2
  },
  {
    uid: '51',
    schematicId: '51',
    name: 'SELKIRK JUNCTION',
    code: 'SELTRM',
    abbrevation: 'SEL',
    startX: 2853,
    startY: 345,
    direction: 2
  },
  {
    uid: '52',
    schematicId: '52',
    name: 'SIDNEY JUNCTION',
    code: 'SIDTRM',
    abbrevation: 'SID',
    startX: 1173,
    startY: 905,
    direction: 2
  },
  {
    uid: '61',
    schematicId: '61',
    name: 'WAYCROSS JUNCTION',
    code: 'WAXTRM',
    abbrevation: 'WAX',
    startX: 1453,
    startY: 2585,
    direction: 2
  },
  {
    uid: '36',
    schematicId: '36',
    name: 'MASSENA JUNCTION',
    code: 'MASTRM',
    abbrevation: 'MAS',
    startX: 2573,
    startY: 65,
    direction: 2
  },
  {
    uid: '7',
    schematicId: '7',
    name: 'CARTERSVILLE JUNCTION',
    code: 'CVLTRM',
    abbrevation: 'CVL',
    startX: 1173,
    startY: 2025,
    direction: 2
  },
  {
    uid: '22',
    schematicId: '22',
    name: 'ETOWAH JUNCTION',
    code: 'ETOTRM',
    abbrevation: 'ETO',
    startX: 1173,
    startY: 1745,
    direction: 2
  },
  {
    uid: '49',
    schematicId: '49',
    name: 'RIDGEWAY JUNCTION',
    code: 'RIDTRM',
    abbrevation: 'RID',
    startX: 1733,
    startY: 905,
    direction: 2
  },
  {
    uid: '24',
    schematicId: '24',
    name: 'FOSTORIA JUNCTION',
    code: 'FOSTRM',
    abbrevation: 'FOS',
    startX: 2013,
    startY: 625,
    direction: 2
  },
  {
    uid: '13',
    schematicId: '13',
    name: 'CHICAGO JUNCTION',
    code: 'CHGTRM',
    abbrevation: 'CHG',
    startX: 614,
    startY: 625,
    direction: 2
  },
  {
    uid: '53',
    schematicId: '53',
    name: 'SPARTANBURG JUNCTION',
    code: 'SBGTRM',
    abbrevation: 'SBG',
    startX: 1733,
    startY: 1745,
    direction: 2
  },
  {
    uid: '35',
    schematicId: '35',
    name: 'MANCHESTER JUNCTION',
    code: 'MANTRM',
    abbrevation: 'MAN',
    startX: 1173,
    startY: 2585,
    direction: 2
  },
  {
    uid: '62',
    schematicId: '62',
    name: 'WELDON JUNCTION',
    code: 'WELTRM',
    abbrevation: 'WEL',
    startX: 2573,
    startY: 1745,
    direction: 2
  },
  {
    uid: '17',
    schematicId: '17',
    name: 'DESHLER JUNCTION',
    code: 'DESHTRM',
    abbrevation: 'DESH',
    startX: 1173,
    startY: 625,
    direction: 2
  },
  {
    uid: '85',
    schematicId: '85',
    name: 'ATLANTA JUNCTION',
    code: 'ATLTRM',
    abbrevation: 'ATL',
    startX: 1455,
    startY: 2025,
    direction: 2
  },
  {
    uid: '86',
    schematicId: '86',
    name: 'GREENWOOD JUNCTION',
    code: 'GWDTRM',
    abbrevation: 'GWD',
    startX: 1733,
    startY: 2025,
    direction: 2
  },
  {
    uid: '87',
    schematicId: '87',
    name: 'MONROE JUNCTION',
    code: 'MNRTRM',
    abbrevation: 'MNR',
    startX: 2012,
    startY: 2025,
    direction: 2
  }
];

export let iohLevelTwoCorridorPositions = [
  {
    abbreviation: 'IND',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 556,
          startY: 750,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 1
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 780,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 420,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'CHG',
    approachingNodes: [
      {
        abbrevation: 'BED',
        tablePosition: {
          startX: 290,
          startY: 540,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 951,
          startY: 540,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      },
      {
        abbrevation: 'FIV',
        tablePosition: {
          startX: 290,
          startY: 260,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GRP',
        tablePosition: {
          startX: 556,
          startY: 450,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 1
      },
      {
        abbrevation: 'IND',
        tablePosition: {
          startX: 647,
          startY: 750,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 1
      },
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 370,
          startY: 770,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'FAB',
    approachingNodes: [
      {
        abbrevation: 'ATL',
        tablePosition: {
          startX: 1390,
          startY: 2225,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      },
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 930,
          startY: 2360,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      },
      {
        abbrevation: 'MAN',
        tablePosition: {
          startX: 1215,
          startY: 2450,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'CVL',
    approachingNodes: [
      {
        abbrevation: 'ETO',
        tablePosition: {
          startX: 1120,
          startY: 1840,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      },
      {
        abbrevation: 'ATL',
        tablePosition: {
          startX: 1352,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 750,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'ATL',
    approachingNodes: [
      {
        abbrevation: 'FAB',
        tablePosition: {
          startX: 1160,
          startY: 2225,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'CVL',
        tablePosition: {
          startX: 1260,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 1622,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'VIT',
    approachingNodes: [
      {
        abbrevation: 'JAX',
        tablePosition: {
          startX: 1398,
          startY: 2995,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'TAM',
        tablePosition: {
          startX: 1270,
          startY: 3100,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      },
      {
        abbrevation: 'WIN',
        tablePosition: {
          startX: 1620,
          startY: 3100,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'JAX',
    approachingNodes: [
      {
        abbrevation: 'VIT',
        tablePosition: {
          startX: 1489,
          startY: 2995,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'WAX',
        tablePosition: {
          startX: 1397,
          startY: 2724,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'CLE',
    approachingNodes: [
      {
        abbrevation: 'BUF',
        tablePosition: {
          startX: 2235,
          startY: 470,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 2326,
          startY: 730,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'BUF',
    approachingNodes: [
      {
        abbrevation: 'CLE',
        tablePosition: {
          startX: 2326,
          startY: 470,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'SYR',
        tablePosition: {
          startX: 2467,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'NSH',
    approachingNodes: [
      {
        abbrevation: 'BES',
        tablePosition: {
          startX: 511,
          startY: 2290,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      },
      {
        abbrevation: 'CVL',
        tablePosition: {
          startX: 844,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'LOU',
        tablePosition: {
          startX: 417,
          startY: 1700,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      },
      {
        abbrevation: 'MEM',
        tablePosition: {
          startX: 185,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 275,
          startY: 1340,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'BES',
    approachingNodes: [
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 727,
          startY: 2525,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'MTG',
        tablePosition: {
          startX: 510,
          startY: 2724,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 420,
          startY: 2290,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MTG',
    approachingNodes: [
      {
        abbrevation: 'BES',
        tablePosition: {
          startX: 420,
          startY: 2724,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      },
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 786,
          startY: 2780,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      },
      {
        abbrevation: 'NOL',
        tablePosition: {
          startX: 209,
          startY: 2780,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SPR',
    approachingNodes: [
      {
        abbrevation: 'SEL',
        tablePosition: {
          startX: 2940,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      },
      {
        abbrevation: 'WOR',
        tablePosition: {
          startX: 3310,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'SEL',
    approachingNodes: [
      {
        abbrevation: 'NBE',
        tablePosition: {
          startX: 2886,
          startY: 470,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'SPR',
        tablePosition: {
          startX: 3029,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      },
      {
        abbrevation: 'SYR',
        tablePosition: {
          startX: 2676,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'GAL',
    approachingNodes: [
      {
        abbrevation: 'FOS',
        tablePosition: {
          startX: 1911,
          startY: 560,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'NOW',
        tablePosition: {
          startX: 1550,
          startY: 560,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 1768,
          startY: 740,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 1677,
          startY: 440,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'FOS',
    approachingNodes: [
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 1820,
          startY: 560,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 2195,
          startY: 710,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 1957,
          startY: 410,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'INR',
    approachingNodes: [
      {
        abbrevation: 'HLT',
        tablePosition: {
          startX: 988,
          startY: 1110,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      },
      {
        abbrevation: 'IND',
        tablePosition: {
          startX: 700,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'LOU',
        tablePosition: {
          startX: 790,
          startY: 1180,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 1095,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'WEL',
    approachingNodes: [
      {
        abbrevation: 'CCX',
        tablePosition: {
          startX: 2607,
          startY: 1870,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'POR',
        tablePosition: {
          startX: 2740,
          startY: 1700,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      },
      {
        abbrevation: 'RIC',
        tablePosition: {
          startX: 2520,
          startY: 1600,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'RIC',
    approachingNodes: [
      {
        abbrevation: 'SCO',
        tablePosition: {
          startX: 2120,
          startY: 1375,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAS',
        tablePosition: {
          startX: 2517,
          startY: 1300,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'WEL',
        tablePosition: {
          startX: 2607,
          startY: 1600,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'GRN',
    approachingNodes: [
      {
        abbrevation: 'CHY',
        tablePosition: {
          startX: 2461,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'CLE',
        tablePosition: {
          startX: 2235,
          startY: 730,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'FOS',
        tablePosition: {
          startX: 2100,
          startY: 710,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 1940,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'CHY',
    approachingNodes: [
      {
        abbrevation: 'CHA',
        tablePosition: {
          startX: 2730,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 2370,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'WAS',
        tablePosition: {
          startX: 2607,
          startY: 1020,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'NOW',
    approachingNodes: [
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 1261,
          startY: 540,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 1630,
          startY: 560,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'DESH',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 860,
          startY: 540,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NOW',
        tablePosition: {
          startX: 1347,
          startY: 540,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 1210,
          startY: 740,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 1
      },
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 1330,
          startY: 250,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'TOL',
    approachingNodes: [
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 1250,
          startY: 250,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'DET',
        tablePosition: {
          startX: 1677,
          startY: 190,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'FOS',
        tablePosition: {
          startX: 2047,
          startY: 410,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 1768,
          startY: 440,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'ETO',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 1118,
          startY: 1580,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'CVL',
        tablePosition: {
          startX: 1209,
          startY: 1860,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'CIN',
    approachingNodes: [
      {
        abbrevation: 'ETO',
        tablePosition: {
          startX: 1209,
          startY: 1580,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'HLT',
        tablePosition: {
          startX: 1118,
          startY: 1300,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'LOU',
        tablePosition: {
          startX: 920,
          startY: 1375,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SCO',
        tablePosition: {
          startX: 1510,
          startY: 1375,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CHA',
    approachingNodes: [
      {
        abbrevation: 'CHY',
        tablePosition: {
          startX: 2650,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'PHI',
        tablePosition: {
          startX: 3015,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'HLT',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 1209,
          startY: 1300,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 908,
          startY: 1110,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 1116,
          startY: 1010,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'RID',
    approachingNodes: [
      {
        abbrevation: 'COL',
        tablePosition: {
          startX: 1768,
          startY: 1020,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 1677,
          startY: 740,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 2020,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 1420,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'DILL',
    approachingNodes: [
      {
        abbrevation: 'CCX',
        tablePosition: {
          startX: 2457,
          startY: 1995,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      },
      {
        abbrevation: 'CHS',
        tablePosition: {
          startX: 2330,
          startY: 2150,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'MNR',
        tablePosition: {
          startX: 2092,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CNC',
    approachingNodes: [
      {
        abbrevation: 'MNR',
        tablePosition: {
          startX: 2053,
          startY: 1865,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WAS',
    approachingNodes: [
      {
        abbrevation: 'BAL',
        tablePosition: {
          startX: 2911,
          startY: 1120,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'CHY',
        tablePosition: {
          startX: 2517,
          startY: 1020,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'RIC',
        tablePosition: {
          startX: 2607,
          startY: 1300,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'SYR',
    approachingNodes: [
      {
        abbrevation: 'BUF',
        tablePosition: {
          startX: 2376,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      },
      {
        abbrevation: 'MAS',
        tablePosition: {
          startX: 2518,
          startY: 190,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'SEL',
        tablePosition: {
          startX: 2767,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'LAG',
    approachingNodes: [
      {
        abbrevation: 'BES',
        tablePosition: {
          startX: 635,
          startY: 2525,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'FAB',
        tablePosition: {
          startX: 840,
          startY: 2360,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'MAN',
        tablePosition: {
          startX: 1077,
          startY: 2525,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'MTG',
        tablePosition: {
          startX: 695,
          startY: 2780,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SBG',
    approachingNodes: [
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 1770,
          startY: 1880,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'SAV',
    approachingNodes: [
      {
        abbrevation: 'CHS',
        tablePosition: {
          startX: 2238,
          startY: 2500,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 1675,
          startY: 2420,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'WAX',
        tablePosition: {
          startX: 1540,
          startY: 2550,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'GWD',
    approachingNodes: [
      {
        abbrevation: 'ATL',
        tablePosition: {
          startX: 1530,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'SAV',
        tablePosition: {
          startX: 1770,
          startY: 2420,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'SBG',
        tablePosition: {
          startX: 1675,
          startY: 1880,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'MNR',
        tablePosition: {
          startX: 1910,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'MNR',
    approachingNodes: [
      {
        abbrevation: 'CNC',
        tablePosition: {
          startX: 1780,
          startY: 1695,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'DILL',
        tablePosition: {
          startX: 2180,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 1820,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'MAS',
    approachingNodes: [
      {
        abbrevation: 'SYR',
        tablePosition: {
          startX: 2607,
          startY: 190,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'TER',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 275,
          startY: 780,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 1
      },
      {
        abbrevation: 'EST',
        tablePosition: {
          startX: 155,
          startY: 862,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      },
      {
        abbrevation: 'IND',
        tablePosition: {
          startX: 510,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 366,
          startY: 1340,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SID',
    approachingNodes: [
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 1118,
          startY: 740,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 1
      },
      {
        abbrevation: 'HLT',
        tablePosition: {
          startX: 1209,
          startY: 1010,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 1005,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 1510,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'CHS',
    approachingNodes: [
      {
        abbrevation: 'DILL',
        tablePosition: {
          startX: 2238,
          startY: 2150,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'SAV',
        tablePosition: {
          startX: 2328,
          startY: 2480,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'LOU',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 1011,
          startY: 1375,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 700,
          startY: 1180,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 3
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 509,
          startY: 1700,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'PHI',
    approachingNodes: [
      {
        abbrevation: 'BAL',
        tablePosition: {
          startX: 3167,
          startY: 1020,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'CHA',
        tablePosition: {
          startX: 2935,
          startY: 840,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'KRN',
        tablePosition: {
          startX: 3076,
          startY: 730,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'KRN',
    approachingNodes: [
      {
        abbrevation: 'NBE',
        tablePosition: {
          startX: 2935,
          startY: 580,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      },
      {
        abbrevation: 'PHI',
        tablePosition: {
          startX: 3167,
          startY: 730,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'POR',
    approachingNodes: [
      {
        abbrevation: 'WEL',
        tablePosition: {
          startX: 2660,
          startY: 1700,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'NOL',
    approachingNodes: [
      {
        abbrevation: 'MTG',
        tablePosition: {
          startX: 299,
          startY: 2780,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WAX',
    approachingNodes: [
      {
        abbrevation: 'JAX',
        tablePosition: {
          startX: 1490,
          startY: 2730,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      },
      {
        abbrevation: 'MAN',
        tablePosition: {
          startX: 1266,
          startY: 2550,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      },
      {
        abbrevation: 'SAV',
        tablePosition: {
          startX: 1630,
          startY: 2550,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'CCX',
    approachingNodes: [
      {
        abbrevation: 'DILL',
        tablePosition: {
          startX: 2366,
          startY: 1935,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WEL',
        tablePosition: {
          startX: 2518,
          startY: 1870,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'COL',
    approachingNodes: [
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 1681,
          startY: 1020,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'SCO',
        tablePosition: {
          startX: 1768,
          startY: 1300,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'MAN',
    approachingNodes: [
      {
        abbrevation: 'FAB',
        tablePosition: {
          startX: 1116,
          startY: 2400,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 985,
          startY: 2525,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'WAX',
        tablePosition: {
          startX: 1355,
          startY: 2550,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'NBE',
    approachingNodes: [
      {
        abbrevation: 'KRN',
        tablePosition: {
          startX: 3015,
          startY: 580,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      },
      {
        abbrevation: 'SEL',
        tablePosition: {
          startX: 2795,
          startY: 470,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'SCO',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 1430,
          startY: 1375,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'COL',
        tablePosition: {
          startX: 1677,
          startY: 1300,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'RIC',
        tablePosition: {
          startX: 2212,
          startY: 1375,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'EST',
    approachingNodes: [
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 247,
          startY: 862,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'TAM',
    approachingNodes: [
      {
        abbrevation: 'VIT',
        tablePosition: {
          startX: 1345,
          startY: 3100,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'BAL',
    approachingNodes: [
      {
        abbrevation: 'PHI',
        tablePosition: {
          startX: 2820,
          startY: 1120,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 2
      },
      {
        abbrevation: 'WAS',
        tablePosition: {
          startX: 3076,
          startY: 1020,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'WOR',
    approachingNodes: [
      {
        abbrevation: 'SPR',
        tablePosition: {
          startX: 3220,
          startY: 300,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'FIV',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 370,
          startY: 260,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'GRP',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 647,
          startY: 450,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'DET',
    approachingNodes: [
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 1768,
          startY: 190,
          sortOrder: 1
        },
        arrowDirection: 5,
        trainCount: 2
      }
    ]
  },
  {
    abbreviation: 'WIN',
    approachingNodes: [
      {
        abbrevation: 'VIT',
        tablePosition: {
          startX: 1530,
          startY: 3100,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'BED',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 370,
          startY: 540,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MEM',
    approachingNodes: [
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 277,
          startY: 1960,
          sortOrder: 1
        },
        arrowDirection: 3,
        trainCount: 2
      }
    ]
  }
];
